export default {
  setIsNeedApproveInterviews(value) {
    return axios
      .put('/dashboard/interviews/set-is-need-approve', {is_need_approve_interviews: value})
      .then(response => response.data);
  },
};
